import { Injectable } from '@angular/core';
import { CaiApi } from '../../utils/cai-api';
import { IShipperQuoteRequest } from '../../model/shipper-quote-request.model';
import { API_CORE } from '../../constant/api-core.const';
import { ShipperQuoteStatusEnum } from '../../enum';
import { IShipperQuoteRequestMetadata } from '../../model/shipper-quote-request-metadata.model';
import { IPaginationResults } from '../../model/pagination-result.model';

@Injectable({
  providedIn: 'root',
})
export class ShipperQuoteService {
  async createShipperQuoteRequest(
    body: IShipperQuoteRequest,
  ): Promise<IShipperQuoteRequest> {
    const url = API_CORE.URLs.ShipperQuote.ShipperQuoteRequests;
    return CaiApi.post(API_CORE.name, url, { body });
  }

  async setShipperQuoteStatus(
    quoteRequestId: number,
    quoteId: number,
    body: ShipperQuoteStatusEnum,
  ) {
    const url = API_CORE.URLs.ShipperQuote.ShipperQuoteOfRequest.replace(
      '{quoteRequestId}',
      quoteRequestId.toString(),
    ).replace('{quoteId}', quoteId.toString());
    return CaiApi.patch(API_CORE.name, url, { body });
  }

  async getShipperQuoteRequests(
    page: number,
    size: number,
    sort: string,
    frequentFilter?: string,
    fromDate?: Date,
    toDate?: Date,
    origin?: string,
    destination?: string,
    airline?: string,
    commodity?: string,
    search?: string,
  ): Promise<IPaginationResults<IShipperQuoteRequest>> {
    const extraOptions = {
      queryParams: {
        page,
        size,
        sort,
      } as any,
    };
    if (frequentFilter) {
      extraOptions.queryParams.frequentFilter = frequentFilter;
    }
    if (fromDate) {
      extraOptions.queryParams.fromDate = fromDate;
    }
    if (toDate) {
      extraOptions.queryParams.toDate = toDate;
    }
    if (origin) {
      extraOptions.queryParams.origin = origin;
    }
    if (destination) {
      extraOptions.queryParams.destination = destination;
    }
    if (airline) {
      extraOptions.queryParams.airline = airline;
    }
    if (commodity) {
      extraOptions.queryParams.commodity = commodity;
    }
    if (search) {
      extraOptions.queryParams.search = search;
    }
    return CaiApi.get(
      API_CORE.name,
      API_CORE.URLs.ShipperQuote.ShipperQuoteRequests,
      extraOptions,
    );
  }

  async getShipperQuoteRequestsMetadata(
    fromDate?: Date,
    toDate?: Date,
    origin?: string[],
    destination?: string[],
    airline?: string[],
    commodity?: string[],
    search?: string,
  ): Promise<IShipperQuoteRequestMetadata> {
    const extraOptions = {
      queryParams: {} as any,
    };
    if (fromDate) {
      extraOptions.queryParams.fromDate = fromDate;
    }
    if (toDate) {
      extraOptions.queryParams.toDate = toDate;
    }
    if (origin) {
      extraOptions.queryParams.origin = origin;
    }
    if (destination) {
      extraOptions.queryParams.destination = destination;
    }
    if (airline) {
      extraOptions.queryParams.airline = airline;
    }
    if (commodity) {
      extraOptions.queryParams.commodity = commodity;
    }
    if (search) {
      extraOptions.queryParams.search = search;
    }
    return CaiApi.get(
      API_CORE.name,
      API_CORE.URLs.ShipperQuote.Metadata,
      extraOptions,
    );
  }

  async downloadPdf(quoteRequestId: number): Promise<any> {
    return CaiApi.get(
      API_CORE.name,
      API_CORE.URLs.ShipperQuote.DownloadPdf.replace(
        '{quoteRequestId}',
        quoteRequestId.toString(),
      ),
      {},
    );
  }
}
